/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Religious_Studies22Inputs */

const en__field__enum_studyprograms_study_religious_studies22 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Religious_Studies22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Religious Studies`)
};

const de__field__enum_studyprograms_study_religious_studies22 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Religious_Studies22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Religionswissenschaft`)
};

/**
* | output |
* | --- |
* | "Religious Studies" |
*
* @param {_Field__Enum_Studyprograms_Study_Religious_Studies22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_religious_studies22 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Religious_Studies22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Religious_Studies22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_religious_studies22(inputs)
	return de__field__enum_studyprograms_study_religious_studies22(inputs)
});
export { _field__enum_studyprograms_study_religious_studies22 as "_field__enum_studyPrograms_STUDY_RELIGIOUS_STUDIES" }